/**
 * A shared component that specifies the icon to represent a cart
 */

export default function CartIcon() {
  return (
    <svg
      width="26"
      height="28"
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.69155 4.44434C5.65798 4.44434 4.76665 5.13509 4.55994 6.09447L1.81388 18.858C1.5389 20.1359 2.56867 21.3332 3.94549 21.3332H19.0545C20.4313 21.3332 21.4611 20.1359 21.1861 18.858L18.44 6.09447C18.2333 5.13317 17.342 4.44434 16.3084 4.44434H9.73076"
        stroke="#575FA5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0385 7.11114V4.92728C15.0385 2.69726 13.4544 0.888916 11.5 0.888916C9.54565 0.888916 7.96155 2.69726 7.96155 4.92728V7.11114"
        stroke="#575FA5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.96152 8.88886C8.45008 8.88886 8.84613 8.49089 8.84613 7.99997C8.84613 7.50905 8.45008 7.11108 7.96152 7.11108C7.47296 7.11108 7.0769 7.50905 7.0769 7.99997C7.0769 8.49089 7.47296 8.88886 7.96152 8.88886Z"
        stroke="#575FA5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0385 8.88886C15.527 8.88886 15.9231 8.49089 15.9231 7.99997C15.9231 7.50905 15.527 7.11108 15.0385 7.11108C14.5499 7.11108 14.1539 7.50905 14.1539 7.99997C14.1539 8.49089 14.5499 8.88886 15.0385 8.88886Z"
        stroke="#575FA5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.73077 19.5557H17.6923"
        stroke="#575FA5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.30768 19.5557H7.07691"
        stroke="#575FA5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
